/**
 * @voltxampere/schema — Migration 0.1.0 → 0.2.0 (Sprint 7)
 *
 * Sprint 7 promoted the Sprint 4 placeholder `bjt` / `mosfet`
 * component types to polarity-specific canonical variants:
 *
 *     bjt      →  bjt-npn     (default NPN assumption)
 *     mosfet   →  mosfet-nmos (default NMOS assumption)
 *
 * Circuits saved under schema 0.1.0 may reference the old type
 * strings. This migrator rewrites them in place and bumps the
 * `schemaVersion` field. All other fields pass through unchanged.
 *
 * The NPN / NMOS default was chosen because it matches the most
 * common usage pattern (beginner circuits are overwhelmingly NPN/
 * NMOS) and because any user explicitly designing with a PNP /
 * PMOS would have used the Sprint 4 `params.polarity` field — we
 * check that and upgrade `bjt` with `polarity: "pnp"` to
 * `bjt-pnp`, not `bjt-npn`. Same logic for MOSFET.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
function migrateComponent(c) {
    if (typeof c !== "object" || c === null)
        return c;
    const comp = c;
    const type = comp.type;
    if (type !== "bjt" && type !== "mosfet")
        return c;
    const params = typeof comp.params === "object" && comp.params !== null
        ? comp.params
        : {};
    const polarity = params.polarity;
    const remaining = { ...params };
    delete remaining.polarity;
    let newType;
    if (type === "bjt") {
        newType = polarity === "pnp" ? "bjt-pnp" : "bjt-npn";
    }
    else {
        newType = polarity === "pmos" ? "mosfet-pmos" : "mosfet-nmos";
    }
    return { ...comp, type: newType, params: remaining };
}
export const migration_0_1_0_to_0_2_0 = {
    from: "0.1.0",
    to: "0.2.0",
    description: "Sprint 7: bjt → bjt-npn/bjt-pnp and mosfet → mosfet-nmos/mosfet-pmos type split",
    migrate(circuit) {
        if (typeof circuit !== "object" || circuit === null) {
            return circuit;
        }
        const raw = circuit;
        const components = Array.isArray(raw.components)
            ? raw.components.map(migrateComponent)
            : raw.components;
        return { ...raw, schemaVersion: "0.2.0", components };
    },
};
//# sourceMappingURL=0.1.0-to-0.2.0.js.map